/* eslint-disable no-shadow */

import $ from 'jquery';
import _ from 'lodash';

import { csrfTokenReady } from '@zapier/toolbox-browser-fetch';
import { getTld } from '@zapier/common-utils';
import { stripLeadingSlash } from '@zapier/url-utils';

import ZeroClipboard from 'app/legacy/vendor/zeroclipboard';
import _str from 'app/common/underscore-string';
import config from 'app/common/Config';
import z from 'app/common/z';
import { BUILDER_URL } from 'app/developer/constants';
import { exists, get } from 'app/common/CommonUtils';

// useful functions

z.useful = {};

/* deprecated! use z.store instead
 * z.cookie = {}
 */

z.cfg.renderContext = {};

// persist layer into local storage

z.store = {};

/* a/b tests that are running
 * bootstrapped in by django snippets/abtests.html
 */

z.tests = window.tests;

/* STATIC VARIABLE ASSIGNMENT */

// by default, all backbone models and collections will pull from this path

z.cfg.api = z.cfg.api || '/api/v3';

z.cfg.newapi = '/api/v3';

z.cfg.devapi = '/api/developer/v1';

z.cfg.devpath = stripLeadingSlash(BUILDER_URL);

z.cfg.devguidedzapspath = 'developer/zap-templates';

z.cfg.devdocspath = 'developer/documentation';

const tld = getTld();

z.cfg.prometheusapi = `https://prometheus.zapier.${tld || 'com'}/api/v1`;

z.cfg.statuspage =
  tld === 'ninja'
    ? 'https://zapier-staging.statuspage.io'
    : 'https://status.zapier.com';

// true if on dev, false if on prod

if (exists(window.DEBUG)) {
  z.cfg.debug = window.DEBUG;
}

// relative path for static media files

if (exists(config.mediaUrl)) {
  z.cfg.mediaURL = config.mediaUrl;
}

// current path the user loaded to hit this page

if (exists(config.path)) {
  z.cfg.path = config.path;
}

// store if this browser is push state enabled

z.cfg.hasPushState = exists(window.history.pushState);

// stripe public key for use in that library

if (exists(config.stripePubApiKey)) {
  z.cfg.stripePubApiKey = config.stripePubApiKey;
}

// braintree public key

if (exists(config.braintreePubApiKey)) {
  z.cfg.braintreePubApiKey = config.braintreePubApiKey;
}

// <title> to append to every page

if (exists(config.titleAppend)) {
  z.cfg.title = config.titleAppend;
}

// milliseconds to wait (globally) before showing a 'cursor' loading animation

z.cfg.cursorLoadAnimTimeout = 0;

// access to the current browser location

z.cfg.location = window.location;

/* if no support tags specified, this one gets applied when the user clicks
 * for support from the app somewhere
 */

z.cfg.defaultSupportTags = 'default';

// our generic userfill tags, used in many places to do replacing

z.cfg.userfillOTag = '{{';

z.cfg.userfillETag = '}}';

// set max results for contact form search

z.cfg.contactMaxSearchResults = 4;

// array of personas available

if (exists(config.personas)) {
  z.cfg.personas = config.personas;
}

window.$(document).ready(function () {
  // Perform legacy cookie storage, this should be removed once Backbone is gone.
  csrfTokenReady().then(() => {
    const csrf = $.cookie('csrftoken');
    z.cfg.renderContext.csrf = csrf;
    $('input[name="csrfmiddlewaretoken"]', document).val(csrf);
  });

  /* CSRF
   */
  let csrfSafeMethod, externalReferrer, referrer, sameOrigin;
  csrfSafeMethod = function (method) {
    //these HTTP methods do not require CSRF protection
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  };
  sameOrigin = function (url) {
    /* test that a given url is a same-origin URL
     * url could be relative or scheme relative or absolute
     * host + port
     */
    let host, origin, protocol, sr_origin;
    host = document.location.host;
    protocol = document.location.protocol;
    sr_origin = '//' + host;
    origin = protocol + sr_origin;

    /* Allow absolute or scheme relative URLs to same origin
     * or any other URL that isn't scheme relative or absolute i.e relative.
     */
    return (
      url === origin ||
      url.slice(0, origin.length + 1) === origin + '/' ||
      url === sr_origin ||
      url.slice(0, sr_origin.length + 1) === sr_origin + '/' ||
      !/^(\/\/|http:|https:).*/.test(url)
    );
  };
  window.$(document).ajaxSend(function (event, xhr, settings) {
    if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
      /* Send the token to same-origin, relative URLs only.
       * Send the token only if the method warrants CSRF protection
       * Using the CSRFToken value acquired earlier
       */
      return xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
    }
    return undefined;
  });

  /* DEFERRED LOADING
   */

  /* migrate any old cookies into new local() storage
   * z.store.migrate()
   */

  // global render context
  z.cfg.renderContext = {
    mediaURL: z.cfg.mediaURL,
    csrf: $.cookie('csrftoken'),
    path: z.cfg.path,
    devpath: z.cfg.devpath,
    devguidedzapspath: z.cfg.devguidedzapspath,
    devdocspath: z.cfg.devdocspath,
    tests: z.tests,
  };

  // set external referrer into cookie
  referrer = document.referrer;
  if (
    _str.contains(referrer, 'zapier.com') ||
    _str.contains(referrer, 'localhost') ||
    referrer === ''
  ) {
    // null, referrer comes straight from the browser
    externalReferrer = get(z.store.get('external-referrer'), [
      'externalReferrer',
    ]);
  } else {
    // take it from stored value and store it
    externalReferrer = referrer;
    z.store.set('external-referrer', {
      externalReferrer,
    });
  }
  z.externalReferrer = externalReferrer;

  _str.include('Underscore.string', 'string');

  // mustache style templating for underscore where needed
  _.templateSettings = {
    interpolate: /\{\{(.+?)\}\}/g,
  };

  // reassign zeroclipboard lib
  z.useful.clipboard = ZeroClipboard;
  z.useful.clipboard.config({
    moviePath: z.cfg.mediaURL + 'images/flash/ZeroClipboard.swf',
    trustedOrigins: [window.location.protocol + '//' + window.location.host],
    hoverClass: 'hover',
    activeClass: 'active',
    allowScriptAccess: 'always',
  });

  // replace retina 2x images mainly for static content (developer)
  $('img.retina').retina();

  // load youtube replacer extension for video elements
  $('.video').loadYoutubeVideo();

  z.app.support = {};
});
